var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClientContactDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.543,
    height: 73.723,
    viewBox: "0 0 53.543 73.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26800",
    "data-name": "Group 26800",
    transform: "translate(0.949 0.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illis_bekva\\u0308m",
    transform: "translate(12.874 25.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37829",
    "data-name": "Path 37829",
    d: "M436.819,192.99a13.14,13.14,0,0,0-.753,2.539,13.345,13.345,0,1,0,26.335.751c-.035-.275-.081-.549-.133-.818",
    transform: "translate(-435.474 -178.364)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37832",
    "data-name": "Path 37832",
    d: "M488.7,225.86a4.37,4.37,0,0,1,4.448,0",
    transform: "translate(-481.881 -206.656)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37833",
    "data-name": "Path 37833",
    d: "M564.15,225.86a4.37,4.37,0,0,1,4.448,0",
    transform: "translate(-548.109 -206.656)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37834",
    "data-name": "Path 37834",
    d: "M461.93,90.437c1.066-9.129-3.478-15.9-12.608-16.965s-15.336,4.336-16.4,13.465l29.01,3.5Z",
    transform: "translate(-432.92 -73.339)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3751",
    "data-name": "Line 3751",
    x1: 12.492,
    y1: 1.46,
    transform: "translate(26.177 16.77)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37835",
    "data-name": "Path 37835",
    d: "M517.99,281.48s3.659,4.035,6.6,0",
    transform: "translate(-507.591 -256.037)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26799",
    "data-name": "Group 26799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26797",
    "data-name": "Group 26797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mina_produkter",
    "data-name": "Mina produkter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26735",
    "data-name": "Group 26735",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26658",
    "data-name": "Group 26658",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37303",
    "data-name": "Path 37303",
    d: "M36.916,17.808h0l.191-.766-.191-23.6A4.515,4.515,0,0,0,32.4-11.074H4.321A4.513,4.513,0,0,0-.191-6.559v62.8a4.513,4.513,0,0,0,4.513,4.513H32.4a4.514,4.514,0,0,0,4.513-4.513V42.681",
    transform: "translate(0.191 11.074)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26659",
    "data-name": "Group 26659",
    transform: "translate(9.94 66.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37304",
    "data-name": "Path 37304",
    d: "M17.229,0H0",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27301",
    "data-name": "Group 27301",
    transform: "translate(13.358 4.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26660",
    "data-name": "Group 26660",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37305",
    "data-name": "Path 37305",
    d: "M0,0H6.957",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26661",
    "data-name": "Group 26661",
    transform: "translate(10.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37306",
    "data-name": "Path 37306",
    d: "M0,0H.14",
    transform: "translate(0)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClientContactDetails);
export default __webpack_public_path__ + "static/media/Icon_clientContactDetails.9f4300b0963cd4adf453a5abc2defdad.svg";
export { ForwardRef as ReactComponent };